import React, { Component } from "react";
import styled from "styled-components";
import ByDevice from "./SignUps/byDevice"
import ByDeviceWithRegion from "./SignUps/byDeviceWithRegion";

class MobileDeviceExplorer extends Component {
    state = { searchBy: "dd" } // 'week' or 'dd'

    handleChangeTimeFrame = () => {
        this.setState(prev => ({ searchBy: prev.searchBy === "dd" ? "week" : "dd" }));
    }

    render() {
        const { searchBy } = this.state;
        const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
        const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";
        return <Container>
            <h1>
                Mobile explorer
            </h1>
            <div>
                <label>Current Time Frame:</label>&nbsp;
                <span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
                <button onClick={this.handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
            </div>
            <br />

            <h2>{currentDateLabel} by Device</h2>
            <ByDevice date={searchBy} />
            <hr /> 

            <br/>
            <h2>{currentDateLabel} by Device and Region</h2>
            <ByDeviceWithRegion date={searchBy} />
            <hr />

            <br/>

        </Container>
    }
}
const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;


export default MobileDeviceExplorer;